import { generateDatabaseProperties } from ":shared/database/get-table";
import { createModel, type Deck, type DeckIdentifiable } from "../model";
import { getTable, TABLE } from "./shared";
import { database } from ":shared/database/connection";

export async function buildRecord(params: Deck): Promise<DeckIdentifiable> {
	const base = createModel(params);

	return {
		...base,
		...generateDatabaseProperties({ table: TABLE }),
	};
}

export async function createAndSaveRecord(
	params: Deck,
): Promise<DeckIdentifiable> {
	const record = await buildRecord(params);

	await database.transaction("rw", getTable(), async () => {
		await getTable().add(record);
	});
	return record;
}
